export const ActiveMessagesConstants = {
    MASTER: 'master',
    AI_AGENT: 'aiAgent',
    MASTER_STATE: 'master-state',
    PHONE_NUMBER: 'phoneNumber',
    WHATSAPP: 'whatsApp',
    PREVIOUS_STEP: -1,
    NEXT_STEP: 1,
    AUDIENCE_STEP: 0,
    CONTENT_STEP: 1,
    RESPONSE_TARGETING_STEP: 2,
    CAMPAIGN_NAME_STEP: 3,
    HOSTING_IDENTITY_NAME: 'hosting',
    ADMIN_IDENTITY_NAME: 'admin',
    ADMIN_IDENTITY: 'admin@msging.net',
    MSGING_SUFFIX: '@msging.net',
    COMMAND_PREFIX: 'lime://',
    COMMAND_SUFFIX: 'builder.hosting@msging.net/configuration',
    CLUSTER_DEFAULT: 'take',
    DOT_CHARACTER: '.',
    PHONE_NUMBER_LENGTH: 11,
    INTERNATIONAL_PHONE_NUMBER_MAX_LENGTH: 15,
    INTERNATIONAL_PHONE_NUMBER_MIN_LENGTH: 7,
    INVALID_VIDEO_SIZE_ERROR_MESSAGE: 'Attachments larger than 16777216 bytes are not supported',
    BUILDER: 'builder',
    ONBOARDING_STATE: 'onboarding',
    HELPCENTER_PAGE_URI: 'https://help.blip.ai/hc/pt-br/articles/1500011572562-Como-usar-o-Disparador-Individual-para-criar-enviar-e-gerenciar-mensagens-ativas-no-WhatsApp',
    SDK_TYPE: 'SDK',
    OPERATOR_TYPE: 'operador',
    ACTIVE_CAMPAIGN_POSTMASTER: 'postmaster@activecampaign.msging.net',
    BUILDER_POSTMASTER: 'postmaster@builder.msging.net',
    CAMPAIGN_COMMAND_CONTENT_TYPE: 'application/vnd.iris.activecampaign.campaign+json',
    MESSAGE_COMMAND_CONTENT_TYPE: 'application/vnd.iris.activecampaign.message+json',
    AUDIENCE_COMMAND_CONTENT_TYPE: 'application/vnd.iris.activecampaign.audience+json',
    VALIDATE_AUDIENCE_FILE_CONTENT_TYPE: 'application/vnd.iris.activecampaign.audience-file+json',
    CAMPAIGNS_URI: '/campaigns',
    AUDIENCES_URI: '/audiences',
    DISPATCH_URI: '/dispatch',
    FLOW_STATES: '/flow/states',
    FLOW_IDS: '/flow-id',
    VALIDATE_AUDIENCE_FILE_URI: '/validate/audience-file',
    AUDIENCES_SUMARY_URI: '/audience-summary',
    AUDIENCE_REPORT_URI_OLD: '/audience-report/',
    AUDIENCE_REPORT_URI: '/campaigns/{campaignId}/reports/csv?language={language}',
    MESSAGES_URI: '/messages',
    CAMPAIGN_SCHEDULE_URI: '/campaigns/{campaignId}/schedule',
    AUDIENCES_PARAMS_SEPARATOR: ';',
    MESSAGES_PARAMS_SEPARATOR: ',',
    CAMPAIGN_REPORT_FILE_NAME_PREFIX: 'Campaign_Report_',
    CAMPAIGN_REPORT_FILE_EXTENSION: '.csv',
    PAGINATION_DEFAULT_TAKE: 20,
    PAGINATION_DEFAULT_SKIP: 0,
    SEND_ACTIVE_MESSAGE_STATE: 'auth.application.detail.growth.activeMessages.sendactivemessage',
    ACTIVE_MESSAGE_STATE: 'auth.application.detail.growth.activeMessages',
    ACTIVE_MESSAGE_STATE_MFE: 'auth.application.detail.growth.activeMessagesMfe',
    EDIT_SCHEDULED_CAMPAIGN_STATE: 'auth.application.detail.growth.activeMessages.editEscheduledCampaign',
    EVENT_CONTENT_STEP_MESSAGE_TEMPLATE_CHANGE: 'content-step-mt-change',
    CSV_MIME_TYPES: [
        'text/csv',
        'application/vnd.ms-excel',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    ],
    APPLICATION_ORIGIN: 'ActiveMessagesScreen',
    MAXIMUM_MESSAGE_SIZE: 1024,
};
